import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'

import getErrorMessage from 'utils/getErrorMessage'
import { noticeError } from 'newrelic/newrelic-telemetry'

// Sits above the router and auth gate: without it a render error anywhere outside the
// route-level ErrorBoundary unmounts the whole React tree and leaves a blank page.
export default class RootErrorBoundary extends React.Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, errorInfo) {
    const componentStack = errorInfo?.componentStack || ''
    noticeError(error, {
      boundary: 'root',
      path: window.location.pathname,
      componentStack: componentStack.slice(0, 2000),
    })
  }

  render() {
    const { error } = this.state
    if (!error) {
      return this.props.children
    }

    return (
      <Box p={6}>
        <Typography variant="h4" gutterBottom>
          An Error Occurred. Please Refresh This Page.
        </Typography>
        <Typography color="error" paragraph>
          {getErrorMessage(error)}
        </Typography>
        <Button variant="contained" color="primary" onClick={() => window.location.reload()}>
          Refresh page
        </Button>
      </Box>
    )
  }
}
